<template>
  <div class="card">
    <img :src="img" />
    <div class="text">
      <i class="anyteachicon anyteach-check-circle" />
      <span v-if="version === 1">开卡成功，共解锁 ¥{{ event.course_price + gift.price * gift.num + 200 }} 价值</span>
      <span v-if="version === 2">开卡成功，共解锁 ¥{{ event.course_price + gift.price * gift.num + 25 }} 价值</span>
      <span v-if="version >= 3">开卡成功，共解锁 ¥{{ event.course_price + gift.price * gift.num }} 价值</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["img", "gift", "version", "event"],
}
</script>
<style lang="scss" scoped>
.card {
  padding: 0 5% 15px 5%;
  border-bottom: $border;
  img {
    max-width: 100%;
  }
  .text {
    text-align: center;
    font-size: 0.9rem;
  }
  i {
    color: $blue;
    font-size: inherit;
    margin-right: 5px;
  }
}
</style>
